export default __webpack_public_path__ + "static/media/bv-jewels-bg.1c26f806.png";